export enum KeyStorage {
  token = 'token',
  user = 'user',
  activeFacilityUnitId = 'activeFacilityUnitId',
  activeFacilityUnitUserRole = 'activeFacilityUnitUserRole',
  isAuthenticated = 'isAuthenticated',
}
